// export default {
// AUTH
export const REQUEST_STARTED = "REQUEST_STARTED";
export const REQUEST_COMPLETED = "REQUEST_COMPLETED";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_SIGNUP_SUCCESS = "AUTH_SIGNUP_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const MODE_CHANGE = "MODE_CHANGE";
export const IS_INSTRUCTOR = "IS_INSTRUCTOR";

// }
